var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "new-page-base",
    [
      _c("template", { attrs: { slot: "titleLeft" }, slot: "titleLeft" }, [
        _vm._v("\n    Auditoria - Faturas\n  ")
      ]),
      _vm._v(" "),
      _c(
        "template",
        { attrs: { slot: "titleRight" }, slot: "titleRight" },
        [
          _c(
            "router-link",
            {
              staticClass: "button is-primary",
              attrs: { to: { name: "billing-upload-page" } }
            },
            [_vm._v("\n      Adicionar fatura\n    ")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "button",
              attrs: { to: { name: "create-billing-template" } }
            },
            [_vm._v("\n      Criar novo modelo\n    ")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "button",
              attrs: { to: { name: "billing-my-files-page" } }
            },
            [_vm._v("\n      Meus arquivos\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page-content" },
        [
          _c("billing-filter-area", {
            on: { onFilterChange: _vm.refreshValues }
          }),
          _vm._v(" "),
          _c("billings-totalizers", { attrs: { totalizers: _vm.totalizers } }),
          _vm._v(" "),
          _c("billings-by-lp-table", {
            attrs: {
              loading:
                _vm.loadingBillingsTable ||
                this.$store.state.logisticProviders.loading,
              billings: _vm.billingTableContent
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d1db60a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d1db60a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/PageBillingMain.vue
// module id = null
// module chunks = 